import parsePhoneNumber from 'libphonenumber-js';

export function availableSendSms(phoneNumber) {
  if (!phoneNumber) return false;
  const parts = parsePhoneNumber(phoneNumber) || parsePhoneNumber('+' + phoneNumber);
  if (parts?.country === 'HK') {
    return true;
  }
  return false;
}
